import { Typography } from "@mui/material";
import englishTranslations from "../../i18n/translations/en";
import { darkColors } from "../../theme/colors";

const PlanetXDescription = ({ isMobile }) => {
  return (
    <Typography
      textAlign={isMobile ? "center" : "left"}
      fontSize="clamp(12px, 1vw, 14px)" // Responsive font size starting at 14px
      color={darkColors.gray}
      sx={{ maxWidth: { lg: "600px", xs: "100%" } }}
    >
      {englishTranslations.auth.planetX}
    </Typography>
  );
};

export default PlanetXDescription;
